import React, { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import axios from "axios";
import useSmartBack from "../../../hooks/useSmartBack";

function RegisteredView() {
  const { id } = useParams();
  const handleBack = useSmartBack("/employeeinfo/registeredusers");
  const [userData, setUserData] = useState(null);
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [showEducation, setShowEducation] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.get(
          `${API_BASE_URL}/employeeinfos/registeredView/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUserData(res.data.registeredView[0]);
        console.log(res.data.registeredView);
      } catch (err) {
        console.error("Failed to fetch user data", err);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchUser();
  }, [id, API_BASE_URL, token, setGlobalLoading]);

  if (!userData) return <p className="text-muted">Loading user data...</p>;

  const educationList = [
    {
      name: userData.education_name1,
      specialization: userData.education_specialization1,
      university: userData.education_university1,
      year: userData.education_year1,
      grade: userData.education_grades1,
    },
    {
      name: userData.education_name2,
      specialization: userData.education_specialization2,
      university: userData.education_university2,
      year: userData.education_year2,
      grade: userData.education_grades2,
    },
    {
      name: userData.education_name3,
      specialization: userData.education_specialization3,
      university: userData.education_university3,
      year: userData.education_year3,
      grade: userData.education_grades3,
    },
    {
      name: userData.education_name4,
      specialization: userData.education_specialization4,
      university: userData.education_university4,
      year: userData.education_year4,
      grade: userData.education_grades4,
    },
    {
      name: userData.other_education_name,
      specialization: userData.other_education_specialization,
      university: userData.other_education_university,
      year: userData.other_education_year,
      grade: userData.other_education_grades,
    },
  ].filter(
    (edu) =>
      edu.name &&
      edu.name.trim() !== "" &&
      edu.university &&
      edu.university.trim() !== ""
  );

  return (
    <div className="content">
      <div className="row align-items-center mb-4">
        <div className="col-sm-6">
          <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
            <p className="mb-0">
              <a
                href="/employeeinfo/registeredusers"
                onClick={(event) => {
                  event.preventDefault();
                  handleBack();
                }}
                className="text-gray d-inline-flex align-items-center"
              >
                <i className="ti ti-arrow-left me-2"></i>Back to Registered
                users
              </a>
            </p>
          </h6>
        </div>

        <div className="col-sm-12 col-md-6">
          <div
            className="d-flex gap-2 justify-content-end"
            style={{ whiteSpace: "nowrap" }}
          >
            <a
              href="javascript:void(0);"
              className="btn btn-dark d-inline-flex align-items-center flex-shrink-0"
            >
              <i className="ti ti-user-off me-2"></i>Candidate Drop
            </a>
            <a
              href="javascript:void(0);"
              className="btn btn-dark d-inline-flex align-items-center flex-shrink-0"
            >
              <i className="ti ti-link me-2"></i>Send Registration Link
            </a>
            <a
              href="javascript:void(0);"
              className="btn btn-dark d-inline-flex align-items-center flex-shrink-0"
            >
              <i className="ti ti-mail-opened me-2"></i>Send 1st Email
            </a>
            <a
              href="javascript:void(0);"
              className="btn btn-dark d-inline-flex align-items-center flex-shrink-0"
            >
              <i className="ti ti-mail-forward me-2"></i>Send 2nd Email
            </a>
            <a
              href="javascript:void(0);"
              className="btn btn-dark d-inline-flex align-items-center flex-shrink-0"
            >
              <i className="ti ti-user-plus me-2"></i>Add to Employee
            </a>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-4 theiaStickySidebar">
          <div className="card card-bg-1">
            <div className="card-body p-0">
              <span
                className="avatar avatar-xl border bg-white rounded-circle m-auto d-flex mb-2"
                style={{
                  width: "100px", //  Adjust size here
                  height: "100px", //  Same height to keep it a circle
                  overflow: "hidden", //  Crop overflow
                }}
              >
                <img
                  src={
                    userData.photo
                      ? `https://pinepositivemoves.com/files/media/${userData.photo}`
                      : "https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg"
                  }
                  alt="Profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", //  Ensures proper fit without distortion
                  }}
                />
              </span>
              <div className="text-center px-3 pb-3 border-bottom">
                <h5 className="d-flex align-items-center justify-content-center mb-1">
                  {userData.Fullname}
                </h5>
                <p className="text-dark">{userData.designation}</p>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6>Employee Details</h6>
                  <a
                    href="javascript:void(0);"
                    className="btn btn-icon btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_company"
                  >
                    {/* <i className="ti ti-edit"></i> */}
                  </a>
                </div>
                {/* <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-id me-2"></i>
                    Emp_id
                  </span>
                  <p className="text-dark">{userData.id || "Not available"}</p>
                </div> */}

                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-phone me-2"></i>
                    Phone
                  </span>
                  <p className="text-dark">
                    {userData.phone || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-mail-check me-2"></i>
                    Email
                  </span>

                  {/* <a href="javascript:void(0);" className="text-info d-inline-flex align-items-center">darlee@example.com <i className="ti ti-copy text-dark ms-2"></i></a> */}
                  <a href={`mailto:${userData.email}`}>{userData.email}</a>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-gender-male me-2"></i>
                    Date of joining
                  </span>
                  <p className="text-dark">
                    {" "}
                    {userData.doj || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    DOB
                  </span>
                  <p className="text-dark"> {userData.dob}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    PAN
                  </span>
                  <p className="text-dark"> {userData.pan_card}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    Role Type
                  </span>
                  <p className="text-dark"> {userData.role_type}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    Nationality
                  </span>
                  <p className="text-dark">
                    {" "}
                    {userData.nationality || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    Marital Status
                  </span>
                  <p className="text-dark">
                    {" "}
                    {userData.maritial_status || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    Spouse Name
                  </span>
                  <p className="text-dark">
                    {" "}
                    {userData.spouse_name || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    Spouse D.O.B
                  </span>
                  <p className="text-dark">
                    {" "}
                    {userData.spouse_dob || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-user-check me-2"></i>
                    Buddy
                  </span>
                  <p className="text-dark">
                    {userData.buddyfirst || "Not available"}{" "}
                    {userData.buddylast}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-8">
          <div>
            <div className="tab-content custom-accordion-items">
              <div
                className="tab-pane active show"
                id="bottom-justified-tab1"
                role="tabpanel"
              >
                <div
                  className="accordion accordions-items-seperate"
                  id="accordionExample"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="accordion-item">
                        <div className="row">
                          <div className="accordion-header" id="headingTen">
                            <div className="accordion-button">
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Other Details</h5>
                                <div className="d-flex">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_details"
                                  >
                                    {/* <i className="ti ti-edit"></i> */}
                                  </a>
                                  <a
                                    href="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderTenn"
                                    aria-expanded="true"
                                    aria-controls="primaryBorderTenn"
                                  >
                                    <i className="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderTenn"
                            className="accordion-collapse collapse "
                            aria-labelledby="headingTen"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Food Preferences
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.food_preference ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Cambridge University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Foreign Language
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.language || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Beverages
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.beverages || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Parking Slot
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.parking || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Interest/Hobby
                                      </h6>
                                    </div>
                                    <p
                                      className="text-dark"
                                      style={{
                                        textAlign: "right",
                                        textWrap: "balance",
                                      }}
                                    >
                                      {userData.interest || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Work Visa
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.visa || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Country
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.country || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Till When
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.pancard || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Passport Number
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.passport_number ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Place of Issue
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.issue_place || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Issue Date
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.issue_date || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Expiry Date
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.exp_date || "Not available"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="accordion-item">
                        <div className="row">
                          <div className="accordion-header" id="headingEleven">
                            <div className="accordion-button collapsed">
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Emergency contact</h5>
                                <div className="d-flex">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_emergency"
                                  >
                                    {/* <i className="ti ti-edit"></i> */}
                                  </a>
                                  <a
                                    href="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderElevenn"
                                    aria-expanded="true"
                                    aria-controls="primaryBorderElevenn"
                                  >
                                    <i className="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderElevenn"
                            className="accordion-collapse collapse "
                            aria-labelledby="headingEleven"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Blood Group
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.blood_group || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Allergies / Health Issue
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.health_issue || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Current Medication
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.current_medication ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Any Advise
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.emergency_contact_name ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Emergency Name(1)
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.emergency_name1 ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Emergency Contact No1
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.emergency_number1 ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Emergency Name(2)
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.emergency_name2 ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Emergency Contact No2
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {userData.emergency_number2 ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <div className="accordion-header">
                      <div className="accordion-button d-flex justify-content-between">
                        <h5>Education Details</h5>
                        <button
                          onClick={() => setShowEducation(!showEducation)}
                          className="btn btn-icon btn-sm ms-auto"
                          title={showEducation ? "Hide" : "Show"}
                        >
                          <i
                            className={`ti ti-chevron-${
                              showEducation ? "up" : "down"
                            }`}
                          ></i>
                        </button>
                      </div>
                    </div>

                    {showEducation && (
                      <div className="accordion-body">
                        {educationList.length > 0 ? (
                          <div style={{ overflowX: "auto" }}>
                            <table
                              className="table table-bordered"
                              style={{ minWidth: "600px" }}
                            >
                              <thead>
                                <tr>
                                  <th>Degree</th>
                                  <th>Specialization</th>
                                  <th>University</th>
                                  <th>Year</th>
                                  <th>Grade</th>
                                </tr>
                              </thead>
                              <tbody>
                                {educationList.map((edu, index) => (
                                  <tr key={index}>
                                    <td>{edu.name}</td>
                                    <td>{edu.specialization}</td>
                                    <td>{edu.university}</td>
                                    <td>{edu.year}</td>
                                    <td>{edu.grade}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p>No education data available.</p>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <div className="accordion-button">
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5>Address Details</h5>
                          <div className="d-flex">
                            <a
                              href="#"
                              className="btn btn-icon btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#edit_familyinformation"
                            >
                              {/* <i className="ti ti-edit"></i> */}
                            </a>
                            <a
                              href="#"
                              className="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderThree"
                              aria-expanded="false"
                              aria-controls="primaryBorderThree"
                            >
                              <i className="ti ti-chevron-down fs-18"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderThree"
                      className="accordion-collapse collapse border-top"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <td>
                                  <strong>Present Address</strong>
                                </td>
                                <td>
                                  {userData.present_address || "Not available"}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Permanent Address</strong>
                                </td>
                                <td>
                                  {userData.permanent_address ||
                                    "Not available"}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisteredView;
